import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="not-found-page">
      <section className="section-padding bg-white min-h-screen flex items-center">
        <div className="container-custom text-center">
          <h1 className="text-9xl font-bold text-accent mb-4">404</h1>
          <h2 className="text-4xl font-bold text-primary mb-6">Page Not Found</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/" className="btn-primary">
            Return Home
          </Link>
        </div>
      </section>
    </div>
  )
}

export default NotFound